'use client';

import React, { memo, useMemo, useRef, useState, useEffect } from 'react';

import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  /** id */
  id?: string;
  /** className */
  className?: string;
  /** type */
  type?: 'type1' | 'type2' | 'type3';
  /** name */
  name?: string;
  /** value */
  value?: string | number;
  /** disabled */
  disabled?: boolean;
  /** checked */
  checked?: boolean;
  /** label */
  label?: React.ReactNode;
  /** children */
  children?: React.ReactNode;
  /** onChange */
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox = ({
  id,
  className,
  type = 'type1',
  name = '',
  value = '',
  disabled = false,
  checked = false,
  label,
  children,
  onChange,
}: IProps) => {
  const ref = useRef<HTMLInputElement>(null);
  const [chk, setChk] = useState(checked);

  // 초기화
  useEffect(() => {
    setChk(checked);
  }, [checked]);

  const param = {
    htmlFor: id,
    className: useMemo(
      () =>
        classNameBind([
          'checkbox',
          disabled ? 'disabled' : '',
          `check-${type}`,
          className || '',
        ]),
      [disabled, type, className]
    ),
  };

  const paramInp: any = {
    id: id || undefined,
    name: name || undefined,
    value,
    type: 'checkbox',
    disabled,
    checked: chk,
    ref,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(e);
      }
      if (!e.defaultPrevented) setChk(e.target.checked);
    },
  };

  // ITEM RENDERER : getInpRender
  const chkInnerMap = {
    type1: <S.ChkInner className="chk-inner chk-inner1" />,
    type2: <S.ChkInner02 className="chk-inner chk-inner2" />,
    type3: <S.ChkInner03 className="chk-inner chk-inner3" />,
  };

  const getInpRender = () => (
    <>
      <S.Input {...paramInp} />
      {chkInnerMap[type]}
      {(children || label) && (
        <S.Label className="label">{children || label}</S.Label>
      )}
    </>
  );

  return <S.Box {...param}>{getInpRender()}</S.Box>;
};

export default memo(Checkbox);
